// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_EDIT_PRODUCT_title_MODIFIED_SUCCESSFULLY = "Inzer\u00e1t \"%(title)s\" byl \u00fasp\u011b\u0161n\u011b zm\u011bn\u011bn\u00fd.";
